import React from 'react'

const BuilderMapView = ({ children }) => {
  return <section>{children}</section>
}

export default BuilderMapView



// WEBPACK FOOTER //
// ./src/Containers/BuilderMap/component/BuilderMapView.js